import * as angular from "angular";
import {IController} from "angular";

export class SupplyAccountThreeplSideNavTabsComponent implements IController {

  constructor() {
  }

}

angular
  .module('bringoz.admin.accounts')
  .component('supplyAccountThreeplSideNavTabs', {
    template: require('./supply-account-threepl-side-nav-tabs.html').default,
    controller: SupplyAccountThreeplSideNavTabsComponent
  });
